import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,ToastController,
  LoadingController,AlertController } from 'ionic-angular';
import { HttpClient,HttpResponse } from '@angular/common/http';

//Page
import { LoginPage } from '../login/login';

//service
import { AppSharedService } from '../service/app_shared';

@IonicPage()
@Component({
  selector: 'page-forgetpassword',
  templateUrl: 'forgetpassword.html',
})
export class ForgetpasswordPage {
  
  // class variable
  username:string;
 
  constructor(public navCtrl: NavController, 
              public navParams: NavParams,
              private toastCtrl: ToastController,
              private http: HttpClient,
              private loadingCtrl : LoadingController,
              public appSharedService:AppSharedService,
              public alertCtrl: AlertController
              ) {
        // initialize
        this.username="";
  }

  ionViewDidLoad() {

  }
  doRequest(){
    if(this.validateLogin())
    {
       
    //create loader
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });

    // show loader
    loading.present();

    // do the service call
    //let url='https://test.bazaarhub.in/api/common/requestreset'
    let url='http://localhost:52832/api/common/requestreset'
    //url= url+'/'+this.username.trim();

    let data={
      KeyWord:this.username.trim()
    }
    this.http.post(url,data,{observe:'response'})
    .subscribe((res: HttpResponse<any>) => {   
      if(res.status==200){
        if(res.body!=undefined && res.body!=null){

           let message=this.appSharedService.getHttpResponseMessage(res,"Please provide correct information");
               
           loading.dismiss();
                // show success message
                this.alertCtrl.create({
                  title: 'Info',
                  subTitle: message,
                  buttons: ['OK']
                }).present();
        }
      }else{
        loading.dismiss();
      }
    });
    }
  }
  doLogin(){
    this.navCtrl.setRoot(LoginPage);
  }
  validateLogin(){
    if(this.username.trim()==""){
      this.toastCtrl.create({
        message: "Please enter  valid email or mobile number",
        duration: 5000
      }).present();
      return false;
    }
    return true
  }
}



// WEBPACK FOOTER //
// ./src/pages/forgetpassword/forgetpassword.ts